import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { appPath } from '../../../constants';
import { getOrientationDetails, addOrientationAttendees, deleteOrientationAttendee } from '../../../actions/orientations';
import { clearWorkersPredictionsList, getWorkersByStatus } from '../../../actions/users';
import { UIShowConfirm } from '../../../actions/ui';
import BackArrow from '../../common/ui/BackArrow';
import { getDateWithOffset, renderDateWithTimeZone } from '../../../helpers/timezones';
import { timeFormatShort, defaultTimeZone, dayDateFormat } from '../../../constants/date';
import ProspectsList from '../prospectsList'

class OrientationDetails extends Component {
  static propTypes = {
    orientationDetails: PropTypes.object.isRequired,
    workersPredictionsList: PropTypes.array.isRequired,
    getOrientationDetails: PropTypes.func.isRequired,
    addOrientationAttendees: PropTypes.func.isRequired,
    deleteOrientationAttendee: PropTypes.func.isRequired,
    clearWorkersPredictionsList: PropTypes.func.isRequired,
    getWorkersByStatus: PropTypes.func.isRequired,
    UIShowConfirm: PropTypes.func.isRequired
  };

  updateDetails = () => {
    const { match: { params: { id } }, getOrientationDetails } = this.props;
    getOrientationDetails(id)
  }

  componentDidMount () {
    const { match: { params: { id } }, history } = this.props;
    if (isNaN(id)) {
      history.push(`/${appPath}/orientations`);
    } else {
      this.updateDetails()
    }
  }

  render () {
    const { orientationDetails } = this.props;
    const { location: { name, address, city, state, zip, time_zone_id }, start_date, end_date, seats_remaining, seats } = orientationDetails;
    const timeZone = time_zone_id || defaultTimeZone;
    const startDate = getDateWithOffset(start_date, timeZone).format(dayDateFormat);
    const timeShift = start_date ? renderDateWithTimeZone(start_date, timeFormatShort, timeZone, end_date) : '';
    const { match } = this.props;

    return (
      <div>
        <div className='d-flex align-items-center mb-4'>
          <BackArrow
            history={this.props.history}
            location={this.props.location}
            defaultBackPath={`/${appPath}/orientations`}
          />
          <div>
            <h3 className='mb-1'>{name}</h3>
            <p>{startDate}, {timeShift}</p>
            <p>{ address }, { city }, { state }, { zip }</p>
            <p>Max Seats: { seats }</p>
            <p>Seats Taken: <span className='seats-remaining-num ml-1'>{seats - seats_remaining}</span></p>
            <p>Seats Remaining: <span className='seats-remaining-num ml-1'>{seats_remaining}</span></p>
          </div>
        </div>
        <ProspectsList
          header={false}
          match={match}
          orientation_id={match.params.id}
        />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  orientationDetails: state.orientations.orientationDetails,
  workersPredictionsList: state.users.workersPredictionsList

});

const mapDispatchToProps = {
  getOrientationDetails,
  addOrientationAttendees,
  deleteOrientationAttendee,
  clearWorkersPredictionsList,
  getWorkersByStatus,
  UIShowConfirm
};

export default connect(mapStateToProps, mapDispatchToProps)(OrientationDetails);



// WEBPACK FOOTER //
// ./src/components/app/orientationDetails/index.js